import React from "react";
import PropTypes from "prop-types";
import promiseFinally from "promise.prototype.finally";
import DOMPurify from "dompurify";
promiseFinally.shim();

import Loading from "./Loading.jsx";

export default class MarkdownViewer extends React.Component {
	static propTypes = {
		markdown: PropTypes.string,
	};

	static defaultProps = {
		markdown: "",
	};

	state = {
		loading: true
	};

	componentDidMount(){
		import("marked").then(({ marked }) => {
			this.marked = marked;
		}).catch((err) => {
			console.warn("COULD NOT LOAD MARKED:", err);
		}).finally(() => {
			this.setState({
				loading: false
			});
		});

	}

	render() {
		if(this.state.loading){
			return <Loading/>;
		} else if(!this.marked) {
			return <div>there was a problem loading this preview</div>;
		} else {
			// Markdown can contain raw HTML, and this content comes from the
			// server (audit/cycle descriptions, question text). Sanitize the
			// generated HTML so injected <script>, event handlers (onerror=...)
			// and javascript: links can't run in the moderator's session.
			const markdown = {
				__html: DOMPurify.sanitize(this.marked.parse(this.props.markdown || "")),
			};
			return <div dangerouslySetInnerHTML={markdown } />;
		}
	}
}
